import { render, staticRenderFns } from "./TariffBuilding.vue?vue&type=template&id=5f686132&scoped=true&"
import script from "./TariffBuilding.vue?vue&type=script&lang=js&"
export * from "./TariffBuilding.vue?vue&type=script&lang=js&"
import style0 from "./TariffBuilding.vue?vue&type=style&index=0&id=5f686132&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f686132",
  null
  
)

export default component.exports